import React, { useEffect, useMemo } from 'react'
import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation'
import useGetAllTags from '../../Constants/Tags/Model/useGetAllTags'
import FilterBadge from '../../../common/FilterBadge'
const TagsFilter = (props) => {
  const { translate } = useTranslation()
  const { tagsFilters, setTagsFilters, loading = false, useInner = false } = props
  // eslint-disable-next-line
  const [getAllTags, { data: dataTags, loading: loadingTags, error: errorTags, refetch: refetchTags }] = useGetAllTags()

  useEffect(
    () => {
      getAllTags()
    }, [getAllTags]
  )
  const tags = useMemo(() => {
    return dataTags?.allTags?.docs?.filter(tag => tag.isActive === true) || []
  }, [dataTags])

  const tagOptions = useMemo(() => tags.map(tag => ({
    name: `${tag.name}`,
    id: tag.id,
    className: 'tags-filter-option',
    Component: (
      <span
        className='tags-filter-option-badge'
        style={{
          backgroundColor: tag.backgroundColor,
          color: tag.textColor
        }}
      >
        {tag.name}
      </span>
    )
  })).sort((a, b) => a.name.localeCompare(b.name)), [tags])

  const checkboxSelectorProps = {
    setDataFilters: setTagsFilters,
    direction: 'bottomRight',
    dataFilters: tagsFilters,
    loading: loadingTags || loading,
    data: tagOptions,
    typeFilter: 'users',
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }
  return (
    <>
      <style>
        {`.tags-filter-option .text-title {
          display: none;
        }

        .tags-filter-option-badge {
          display: inline-flex;
          align-items: center;
          border-radius: 999px;
          padding: 0.45rem 1.25rem;
          line-height: 1.25;
        }`}
      </style>
      {useInner ? (
        <CheckboxSelectorInner
          style={{ maxWidth: 'auto' }}
          {...checkboxSelectorProps}
        />
      ) : (
        <CheckboxSelector {...checkboxSelectorProps}>
          <FilterBadge
            title={translate('filters.payments.tagsTitle')}
            options={tagOptions}
            selectedIds={tagsFilters}
            onClearFilters={() => setTagsFilters([])}
          />
        </CheckboxSelector>
      )}
    </>
  )
}
export default TagsFilter
